import { clipEndBar, sessionBarsToNative } from '@/audio/clipTiming';
import { fitsAt } from './pastePlacement';
const EPS=1e-6;
export function sectionRange(marker, markers, totalBars) {
  return {startBar:marker.startBar,endBar:Math.min(totalBars,...markers.filter(m=>m.startBar>marker.startBar).map(m=>m.startBar)),name:marker.name};
}
export function makeSelectionClipboard(tracks, ids, bpm, range=null, markers=[]) {
  const selected=tracks.flatMap(t=>(t.clips||[]).filter(c=>ids.has(c.id)).map(clip=>({trackId:t.id,clip})));
  if (!selected.length) return null;
  const start=range?.startBar??Math.min(...selected.map(i=>i.clip.start_bar));
  const end=range?.endBar??Math.max(...selected.map(i=>clipEndBar(i.clip,bpm)));
  const items=selected.flatMap(item=>{
    const clip=item.clip,from=Math.max(start,clip.start_bar),to=Math.min(end,clipEndBar(clip,bpm));
    if(to<=from+EPS)return [];
    const delta=sessionBarsToNative(from-clip.start_bar,clip,bpm),bars=sessionBarsToNative(to-from,clip,bpm);
    return [{trackId:item.trackId,relativeOffset:from-start,clip:{...structuredClone(clip),start_bar:from,bars,offset:(clip.offset||0)+(clip.reverse?clip.bars-delta-bars:delta),...((from>clip.start_bar+EPS||to<clipEndBar(clip,bpm)-EPS)&&(clip.fade_in||clip.fade_out)?{fadeEnvelope:{bars:clip.fadeEnvelope?.bars??clip.bars,offsetBars:(clip.fadeEnvelope?.offsetBars||0)+delta}}:{})}}];
  });
  return {items,selectionSpan:end-start,markers:range?markers.filter(m=>m.startBar>=start&&m.startBar<end).map(m=>({...m,startBar:m.startBar-start})):[],isSection:Boolean(range)};
}
export function placeSelection(tracks, clipboard, at, bpm, maxBars, uuid) {
  if(!clipboard?.items.length || !clipboard.items.every(i=>tracks.some(t=>t.id===i.trackId)) || at<0 || at+clipboard.selectionSpan>maxBars+EPS || !fitsAt(tracks,clipboard.items,at,bpm))return null;
  const ids=[];
  const next=tracks.map(t=>({...t,clips:[...t.clips,...clipboard.items.filter(i=>i.trackId===t.id).map(i=>{
    const id=uuid();ids.push(id);return {...structuredClone(i.clip),id,start_bar:at+i.relativeOffset};
  })]}));
  return {tracks:next,ids,markers:(clipboard.markers||[]).map(m=>({...m,id:uuid(),startBar:at+m.startBar}))};
}

/** Duplicate inserts room; ordinary Paste remains collision-safe and never moves existing music. */
export function insertSelection(tracks, markers, clipboard, at, bpm, maxBars, uuid) {
  const span=clipboard?.selectionSpan;
  if(!(span>0) || tracks.some(t=>!t.inBank&&(t.clips||[]).some(c=>c.start_bar<at-EPS&&clipEndBar(c,bpm)>at+EPS)))return null;
  const shifted=tracks.map(t=>t.inBank?t:{...t,clips:t.clips.map(c=>c.start_bar>=at-EPS?{...c,start_bar:c.start_bar+span}:c)});
  const shiftedMarkers=markers.map(m=>m.startBar>=at-EPS?{...m,startBar:m.startBar+span}:m);
  if(shifted.some(t=>!t.inBank&&t.clips.some(c=>clipEndBar(c,bpm)>maxBars+EPS))||shiftedMarkers.some(m=>m.startBar>=maxBars))return null;
  const placed=placeSelection(shifted,clipboard,at,bpm,maxBars,uuid);
  return placed?{...placed,sectionMarkers:[...shiftedMarkers,...placed.markers]}:null;
}
